// Environment label banner. Shows a small non-intrusive pill (e.g. "TESTING")
// at the top-center of the screen whenever REACT_APP_ENV_LABEL is set.
// Leave the env var unset in production so the banner never renders there.
const RAW_LABEL = process.env.REACT_APP_ENV_LABEL;

const LABEL_MAP = {
  preview: 'Testing Environment',
  testing: 'Testing Environment',
  staging: 'Staging Environment',
  dev: 'Development',
};

const EnvBanner = () => {
  if (!RAW_LABEL) return null;
  const key = String(RAW_LABEL).trim().toLowerCase();
  const label = LABEL_MAP[key] || RAW_LABEL;

  return (
    <div
      data-testid="env-banner"
      className="fixed top-0 left-1/2 -translate-x-1/2 z-[9999] pointer-events-none"
      aria-hidden="true"
    >
      <div className="flex items-center gap-1.5 bg-[#ffd108] text-[#1a1a1a] text-[10px] font-bold uppercase tracking-wider px-3 py-1 rounded-b-md shadow-md">
        <span className="w-1.5 h-1.5 rounded-full bg-[#1a1a1a] animate-pulse" />
        {label}
      </div>
    </div>
  );
};

export default EnvBanner;
